module.exports = __webpack_public_path__ + "img/page-top-img.fc28e79a.svg";